import AppBarWithMenu from './app-bar-with-menu';

export default AppBarWithMenu;
